import { useFitnessStore } from '../../../store/fitnessStore';
import { Play, ChevronRight } from 'lucide-react';

export default function ExerciseCard({ exercise, compact = false }) {
  const openModal = useFitnessStore((s) => s.openModal);
  if (!exercise) return null;

  const targetColor = {
    quadriceps: '#E8FF47', hamstrings: '#E8FF47', glutes: '#E8FF47',
    pectorals: '#FF6B35', 'upper chest': '#FF6B35',
    lats: '#00D4FF', 'upper back': '#00D4FF',
    delts: '#B47EFF', shoulders: '#B47EFF',
  }[exercise.target?.toLowerCase()] || 'rgba(255,255,255,0.5)';

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => openModal('exercise', exercise)}
      onKeyDown={(e) => e.key === 'Enter' && openModal('exercise', exercise)}
      style={{
        background: '#141416', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 14, overflow: 'hidden',
        cursor: 'pointer', display: 'flex', flexDirection: compact ? 'row' : 'column',
        alignItems: compact ? 'center' : 'stretch', gap: compact ? 12 : 0,
      }}
    >
      <div style={{
        width: compact ? 56 : '100%', height: compact ? 56 : 160, background: '#1C1C1F', flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: compact ? 10 : 0,
      }}
      >
        {exercise.gifUrl ? (
          <img src={exercise.gifUrl} alt={exercise.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: compact ? 10 : 0 }} loading="lazy" />
        ) : (
          <Play size={24} color="rgba(255,255,255,0.2)" />
        )}
      </div>
      <div style={{ padding: compact ? '0 8px 0 0' : '12px', flex: 1 }}>
        <div style={{ fontSize: compact ? 12 : 13, fontWeight: 600, marginBottom: 4, textTransform: 'capitalize' }}>{exercise.name}</div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {exercise.target && (
            <span style={{ fontSize: 9, fontWeight: 600, padding: '2px 7px', borderRadius: 20, background: `${targetColor}18`, color: targetColor }}>{exercise.target}</span>
          )}
          {exercise.equipment && (
            <span style={{ fontSize: 9, padding: '2px 7px', borderRadius: 20, background: 'rgba(255,255,255,0.07)', color: 'rgba(255,255,255,0.5)' }}>{exercise.equipment}</span>
          )}
        </div>
      </div>
      {compact && <ChevronRight size={16} color="rgba(255,255,255,0.2)" style={{ flexShrink: 0 }} />}
    </div>
  );
}
